<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<button type="button" mat-button [ngClass]="{'button-link': asLink}" (click)="getFile()">{{label}}</button>
